const NS = 'CaseStudiesCarouselBlock';
const CLS = 'caseStudiesCarouselBlock';

import Swiper from 'swiper/swiper-bundle.js';
import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';

export class CaseStudiesCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$swiper = this.$element.find(`.${CLS}-swiper`);
		this.$buttonNext = this.$element.find(`.${CLS}-swiper-button-next`);
		this.$buttonPrev = this.$element.find(`.${CLS}-swiper-button-prev`);

		const swiper = new Swiper(this.$swiper[0], {
			speed: 700,
			spaceBetween: 0,
			slidesPerView: 'auto', // scroll 3 at a time instead of 1
			slidesPerGroupAuto: true, // scroll 3 at a time instead of 1
			autoHeight: false,
			// shortSwipes: false,
			navigation: {
				nextEl: this.$buttonNext[0],
				prevEl: this.$buttonPrev[0]
			}
		});

		this.initAnimateScrollReveal(this, CLS);
	}
}

Object.assign(CaseStudiesCarouselBlock.prototype, animateScrollRevealMixinBlock);
